import React from 'react'
import { REQUIRED_FIELD_STATES, RequiredFieldStateCode } from "../../../enums/EtatChampObligatoire"

interface EtatToggleProps {
    value: RequiredFieldStateCode
    onChange: (state: RequiredFieldStateCode) => void
    disabled?: boolean
}

export default function EtatToggle({ value, onChange, disabled = false }: EtatToggleProps) {
    return (
        <div className="btn-group btn-group-sm" role="group">
            {REQUIRED_FIELD_STATES.map(etat => (
                <button
                    key={etat.code}
                    type="button"
                    disabled={disabled}
                    className={"btn " + (value === etat.code ? "btn-eseller-color" : "btn-light")}
                    onClick={() => !disabled && onChange(etat.code)}
                >
                    {etat.label}
                </button>
            ))}
        </div>
    )
}
